/* The Bad Owl Migratory Map — list + interactive map, hotels.com style.
   Leaflet is loaded lazily; if it fails the list still works. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mapapp]');
  if (!root) return;

  var dataEl = document.querySelector('[data-map-data]');
  var PLACES = [];
  try { PLACES = JSON.parse(dataEl.textContent) || []; } catch (e) { PLACES = []; }

  var listEl   = root.querySelector('[data-map-list]');
  var searchEl = root.querySelector('[data-map-search]');
  var countEl  = root.querySelector('[data-map-count]');
  var emptyEl  = root.querySelector('[data-map-empty]');
  var canvas   = root.querySelector('[data-map-canvas]');
  var cards    = Array.prototype.slice.call(root.querySelectorAll('.mapcard'));

  var COLOR = { roost: '#EBCB80', nest: '#8A9A63', pardner: '#A63B2A' };
  var active = { roost: true, nest: true, pardner: true };
  var query = '';
  var map = null, markers = {}, selected = null;

  function matches(p) {
    if (!active[p.type]) return false;
    if (!query) return true;
    var hay = [p.name, p.city, p.region, p.postal, p.address].join(' ').toLowerCase();
    return hay.indexOf(query) !== -1;
  }

  function visible() { return PLACES.filter(matches); }

  function render() {
    var shown = visible();
    var ids = {};
    shown.forEach(function (p) { ids[p.i] = true; });

    cards.forEach(function (c) {
      c.hidden = !ids[c.dataset.placeId];
    });
    if (countEl) {
      countEl.textContent = shown.length + (shown.length === 1 ? ' place' : ' places');
    }
    if (emptyEl) emptyEl.hidden = shown.length !== 0;

    if (map) {
      PLACES.forEach(function (p) {
        var m = markers[p.i];
        if (!m) return;
        if (ids[p.i]) { if (!map.hasLayer(m)) m.addTo(map); }
        else if (map.hasLayer(m)) map.removeLayer(m);
      });
      // don't yank the view away from a place the visitor just picked
      if (selected == null || !ids[selected]) fit(shown);
    }
  }

  function fit(shown) {
    if (!map || !shown.length || !window.L) return;
    if (shown.length === 1) { map.setView([shown[0].lat, shown[0].lng], 12, { animate: true }); return; }
    var b = window.L.latLngBounds(shown.map(function (p) { return [p.lat, p.lng]; }));
    map.fitBounds(b, { padding: [40, 40], maxZoom: 11, animate: true });
  }

  function select(i, pan) {
    selected = i;
    if (map) map.stop();
    cards.forEach(function (c) { c.classList.toggle('on', c.dataset.placeId == i); });
    var p = PLACES[i];
    if (!p) return;
    var card = cards.filter(function (c) { return c.dataset.placeId == i; })[0];
    if (card && listEl) {
      var ct = card.offsetTop - listEl.offsetTop;
      listEl.scrollTo({ top: ct - 12, behavior: 'smooth' });
    }
    if (map && markers[i]) {
      if (pan) map.setView([p.lat, p.lng], Math.max(map.getZoom(), 9), { animate: true });
      markers[i].openPopup();
    }
  }

  function popupHtml(p) {
    var rows = '';
    if (p.type === 'roost') {
      if (p.cigar)   rows += '<dt>Smoke</dt><dd>' + esc(p.cigar) + '</dd>';
      if (p.pairing) rows += '<dt>Pair with</dt><dd>' + esc(p.pairing) + '</dd>';
    } else if (p.type === 'nest') {
      if (p.host)     rows += '<dt>Host</dt><dd>' + esc(p.host) + '</dd>';
      if (p.schedule) rows += '<dt>Meets</dt><dd>' + esc(p.schedule) + '</dd>';
      if (p.members)  rows += '<dt>Members</dt><dd>' + p.members + '</dd>';
    } else if (p.offer) {
      rows += '<dt>Members</dt><dd>' + esc(p.offer) + '</dd>';
    }
    var q = encodeURIComponent([p.name, p.address, p.city, p.region].filter(Boolean).join(', '));
    return '<div class="mappop">' +
      '<span class="tag tag-' + p.type + '">' + p.type + '</span>' +
      '<h3>' + esc(p.name) + '</h3>' +
      '<p class="meta">' + esc([p.city, p.region].filter(Boolean).join(', ')) + '</p>' +
      (p.desc ? '<p class="small">' + esc(p.desc) + '</p>' : '') +
      (rows ? '<dl class="kv">' + rows + '</dl>' : '') +
      '<a class="btn ghost" target="_blank" rel="noopener" href="https://www.google.com/maps/search/?api=1&query=' + q + '">Directions</a>' +
      (p.website ? ' <a class="btn ghost" target="_blank" rel="noopener" href="' + esc(p.website) + '">Website</a>' : '') +
      '</div>';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---- wiring that works with or without the map ---- */
  cards.forEach(function (c) {
    c.addEventListener('click', function () { select(+c.dataset.placeId, true); });
    c.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(+c.dataset.placeId, true); }
    });
    c.addEventListener('mouseenter', function () {
      var m = markers[c.dataset.placeId];
      if (m && m._icon) m._icon.classList.add('hot');
    });
    c.addEventListener('mouseleave', function () {
      var m = markers[c.dataset.placeId];
      if (m && m._icon) m._icon.classList.remove('hot');
    });
  });

  root.querySelectorAll('[data-map-filter]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.dataset.mapFilter;
      active[k] = !active[k];
      b.classList.toggle('on', active[k]);
      render();
    });
  });

  if (searchEl) {
    var t;
    searchEl.addEventListener('input', function (e) {
      clearTimeout(t);
      t = setTimeout(function () { query = e.target.value.toLowerCase().trim(); render(); }, 150);
    });
  }

  /* ---- Leaflet, loaded lazily ---- */
  function loadLeaflet(cb) {
    if (window.L) return cb();
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(css);
    var s = document.createElement('script');
    s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    s.onload = cb;
    s.onerror = function () { canvas.classList.add('map-failed'); render(); };
    document.head.appendChild(s);
  }

  function initMap() {
    var L = window.L;
    if (!L) return;
    map = L.map(canvas, { scrollWheelZoom: false, zoomControl: true })
           .setView([+root.dataset.centerLat || 39.5, +root.dataset.centerLng || -98.35],
                    +root.dataset.zoom || 4);
    // OpenStreetMap standard tiles: no API key, no billing. Tinted via CSS to match the brand.
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19
    }).addTo(map);

    PLACES.forEach(function (p) {
      if (!p.lat && !p.lng) return;
      var icon = L.divIcon({
        className: 'owlpin owlpin-' + p.type,
        html: '<span class="owlpin-dot" style="background:' + (COLOR[p.type] || '#888') + '"></span>',
        iconSize: [18, 18], iconAnchor: [9, 9], popupAnchor: [0, -10]
      });
      var m = L.marker([p.lat, p.lng], { icon: icon, title: p.name })
               .bindPopup(popupHtml(p), { maxWidth: 300 });
      m.on('click', function () { select(p.i, false); });
      markers[p.i] = m;
      m.addTo(map);
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { map.invalidateSize(); }, 200);
    });
    setTimeout(function () { map.invalidateSize(); }, 50);
    render();
  }

  render();
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        loadLeaflet(initMap);
      }
    }, { rootMargin: '200px' });
    io.observe(canvas);
  } else {
    loadLeaflet(initMap);
  }
})();
